import React from "react";

const CreditNotes = () => {
  return <div>Credit note is under construction ⚒️...</div>;
};

export default CreditNotes;
